import React, { useMemo } from 'react'
import { RouteComponentProps } from 'react-router'
import { Expaned } from '@/components/layout/layout'
import {
    MEMBER_BALANCE_OPERATIONS,
    MEMBER_BINDING_RECORD,
    MEMBER_BLACKLIST,
    MEMBER_BIRTHDAY,
    MEMBER_BENEFIT_SETTING,
    MEMBER_CARD_RECORD,
    MEMBER_CARD_SETTING,
    MEMBER_CHAIN_COIN_SETTING,
    MEMBER_DISCOUNT_SETTING,
    MEMBER_GROUP,
    MEMBER_IMPORT,
    MEMBER_GROWTH_RULE_SETTING,
    MEMBER_LEVEL,
    MEMBER_LEVEL_CHANGE_RECORD,
    MEMBER_POINTS_SETTING,
    MEMBER_POINTS_OPERATIONS,
    MEMBER_POINTS_COUPON_MALL,
    MEMBER_PRICE_SETTING,
    MEMBER_RECHARGE_SETTING,
    MEMBER_SVIP_SETTING,
    MEMBER_SVIP_PURCHASE_RECORD,
    MEMBER_SETTING_ASSETS,
    MEMBER_SETTING_BASIC,
    MEMBER_SETTING_CHAIN,
    MEMBER_SETTING_MARKETING,
} from '../router'
import { SettingLinkGrid } from './setting-page'

import './member-setting.scss'

const MemberSetting: React.FC<RouteComponentProps> = props => {
    const settingGroups = useMemo(
        () => [
            {
                title: '基础设置',
                route: MEMBER_SETTING_BASIC,
                items: [
                    {
                        title: '会员卡设置',
                        desc: '会员领卡二维码、卡面和联系方式',
                        route: MEMBER_CARD_SETTING,
                        permission: 20,
                    },
                    { title: '分组管理', desc: '维护会员分组和默认分组', route: MEMBER_GROUP, permission: 19 },
                    { title: '会员生日', desc: '查看生日会员并跟进服务', route: MEMBER_BIRTHDAY },
                    { title: '领卡记录', desc: '查看顾客领卡来源和邀请人', route: MEMBER_CARD_RECORD },
                    { title: '绑定记录', desc: '查看会员账号绑定变化', route: MEMBER_BINDING_RECORD },
                    {
                        title: '会员黑名单',
                        desc: '设置拉黑规则并查看黑名单记录',
                        route: MEMBER_BLACKLIST,
                        permission: 20,
                    },
                    { title: '批量导入', desc: '导入老零售会员或表格会员', route: MEMBER_IMPORT, permission: 19 },
                ],
            },
            {
                title: '资产与权益',
                route: MEMBER_SETTING_ASSETS,
                items: [
                    { title: '积分', desc: '积分记录、抵现和积分榜', route: MEMBER_POINTS_SETTING, permission: 20 },
                    {
                        title: '积分业务',
                        desc: '查看不积分商品、积分榜和抵现记录',
                        route: MEMBER_POINTS_OPERATIONS,
                        permission: 20,
                    },
                    {
                        title: '积分商城',
                        desc: '配置积分兑换优惠券和查看兑换记录',
                        route: MEMBER_POINTS_COUPON_MALL,
                        permission: 35,
                    },
                    { title: '余额/充值', desc: '余额规则和充值配置', route: MEMBER_RECHARGE_SETTING, permission: 20 },
                    { title: '余额业务', desc: '查看当前余额、充值和余额消费榜', route: MEMBER_BALANCE_OPERATIONS },
                    {
                        title: '会员权益',
                        desc: '会员折扣、会员价和权益开关',
                        route: MEMBER_BENEFIT_SETTING,
                        permission: 20,
                    },
                ],
            },
            {
                title: '等级与营销',
                route: MEMBER_SETTING_MARKETING,
                items: [
                    {
                        title: '成长值与会员等级',
                        desc: '设置等级门槛和成长值规则',
                        route: MEMBER_LEVEL,
                        permission: 20,
                    },
                    {
                        title: '成长值规则',
                        desc: '设置消费和充值成长值获取倍数',
                        route: MEMBER_GROWTH_RULE_SETTING,
                        permission: 20,
                    },
                    { title: '等级变更记录', desc: '查询会员等级自动与手动变更', route: MEMBER_LEVEL_CHANGE_RECORD },
                    {
                        title: '会员折扣',
                        desc: '配置不同等级的折扣权益',
                        route: MEMBER_DISCOUNT_SETTING,
                        permission: 20,
                    },
                    { title: '商品会员价', desc: '维护商品会员价权益', route: MEMBER_PRICE_SETTING, permission: 20 },
                    { title: '付费会员', desc: '配置付费会员卡和购买记录', route: MEMBER_SVIP_SETTING, permission: 20 },
                    {
                        title: '付费会员购买记录',
                        desc: '查询全店付费会员购买流水',
                        route: MEMBER_SVIP_PURCHASE_RECORD,
                        permission: 20,
                    },
                ],
            },
            {
                title: '连锁能力',
                route: MEMBER_SETTING_CHAIN,
                items: [
                    { title: '连锁币', desc: '查看和配置连锁币权益', route: MEMBER_CHAIN_COIN_SETTING, permission: 20 },
                ],
            },
        ],
        [],
    )
    const activeGroup = settingGroups.find(group => group.route === props.location.pathname) || settingGroups[0]

    return (
        <Expaned className="member-setting">
            <section className="member-setting__index" key={activeGroup.route}>
                <SettingLinkGrid items={activeGroup.items} columns={3} />
            </section>
        </Expaned>
    )
}

export default MemberSetting
